module.exports = __webpack_public_path__ + "static/img/1676.3c2a588.png";